/**
 * Achievement actions enum as per GQL.
 *
 * @alias ACHIEVEMENT_ACTIONS
 * @enum {string}
 * @type {{SHUTTERBUG_PHOTO_UPLOAD, SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITER, SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITEE}} ACHIEVEMENT_ACTIONS
 */
const ACHIEVEMENT_ACTIONS = {
  SHUTTERBUG_PHOTO_UPLOAD: 'SHUTTERBUG_PHOTO_UPLOAD',
  SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITER:
    'SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITER',
  SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITEE:
    'SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITEE',
};

/**
 * List of achievements to display once an achievement has been unlocked as "banners".
 *
 * @alias ACHIEVEMENT_ACTIONS_LINKED_ACHIEVEMENTS
 * @enum {array<String>}
 * @type {{SHUTTERBUG_PHOTO_UPLOAD, SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITER, SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITEE}} ACHIEVEMENT_ACTIONS_LINKED_ACHIEVEMENTS
 */
const ACHIEVEMENT_ACTIONS_LINKED_ACHIEVEMENTS = {
  [ACHIEVEMENT_ACTIONS.SHUTTERBUG_PHOTO_UPLOAD]: [
    ACHIEVEMENT_ACTIONS.SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITER,
  ],
  [ACHIEVEMENT_ACTIONS.SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITER]: [
    ACHIEVEMENT_ACTIONS.SHUTTERBUG_PHOTO_UPLOAD,
  ],
  [ACHIEVEMENT_ACTIONS.SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITEE]: [
    ACHIEVEMENT_ACTIONS.SHUTTERBUG_INVITE_ACCEPTED_FOR_INVITER,
    ACHIEVEMENT_ACTIONS.SHUTTERBUG_PHOTO_UPLOAD,
  ],
};

/**
 * List of reward types.
 *
 * @alias REWARD_TYPES
 * @enum {array<String>}
 * @type {{SEARCH_CREDITS, PHOTO_STORAGE}} REWARD_TYPES
 */
const REWARD_TYPES = {
  SEARCH_CREDITS: 'SEARCH_CREDITS',
  PHOTO_STORAGE: 'PHOTO_STORAGE',
};

/**
 * Labels for each reward type. This is what they will be presented to the end-consumer as.
 *
 * @alias REWARD_TYPES
 * @enum {array<String>}
 * @type {{SEARCH_CREDITS, PHOTO_STORAGE}} REWARD_TYPES
 */
const REWARD_TYPE_LABEL = {
  [REWARD_TYPES.SEARCH_CREDITS]: 'Photo searches',
  [REWARD_TYPES.PHOTO_STORAGE]: 'Storage',
};

export {
  ACHIEVEMENT_ACTIONS,
  ACHIEVEMENT_ACTIONS_LINKED_ACHIEVEMENTS,
  REWARD_TYPES,
  REWARD_TYPE_LABEL,
};
